import { Directive, Input, Inject } from '@angular/core';
import {
  AsyncValidator,
  AbstractControl,
  ValidationErrors,
  Validators,
  NG_ASYNC_VALIDATORS
} from '@angular/forms';
import {
  VALIDATORS_CONFIGURATION_TOKEN,
  ValidatorsConfiguration
} from '../tokens';
import { Observable, of } from 'rxjs';
import { CommonService } from '@ecosure-suite/shared/utils-helpers';

@Directive({
  selector:
    // tslint:disable-next-line: directive-selector
    '[burialSocietyName][formControlName],[burialSocietyName][formControl],[burialSocietyName][ngModel]',
  providers: [
    {
      provide: NG_ASYNC_VALIDATORS,
      useExisting: BurialSocietyNameValidatorDirective,
      multi: true
    }
  ]
})
export class BurialSocietyNameValidatorDirective implements AsyncValidator {
  @Input() required = undefined;
  @Input() enabled = undefined;

  burialSocietyNameValidator: {
    enabled: boolean;
    required: boolean;
    regex: string;
  };

  constructor(
    @Inject(VALIDATORS_CONFIGURATION_TOKEN)
    configuration: ValidatorsConfiguration
  ) {
    this.burialSocietyNameValidator = configuration.burialSocietyName;
  }

  validate(
    control: AbstractControl
  ): Promise<ValidationErrors> | Observable<ValidationErrors> {
    if (this.required === undefined || this.required === null) {
      if (this.burialSocietyNameValidator.required) {
        const isRequired = Validators.required(control);
        if (CommonService.isDefined(isRequired)) {
          return of(isRequired);
        }
      }
    } else {
      if (this.required) {
        const isRequired = Validators.required(control);
        if (CommonService.isDefined(isRequired)) {
          return of(isRequired);
        }
      }
    }

    if (this.enabled === undefined || this.enabled === null) {
      if (this.burialSocietyNameValidator.enabled) {
        return control.value.match(
          new RegExp(this.burialSocietyNameValidator.regex)
        )
          ? of(null)
          : of({ burialSocietyName: true });
      }
    } else {
      if (this.enabled) {
        return control.value.match(
          new RegExp(this.burialSocietyNameValidator.regex)
        )
          ? of(null)
          : of({ burialSocietyName: true });
      }
    }

    return of(null);
  }
}
